const redirectTo = (url = "https://mywealth.fabits.com/login") => {
  return window.open(url);
};

export default redirectTo;
